import { useEffect, useState } from "react";
import { getSubdomain } from "../utils/getSubdomain";

import { fetchTenant } from "../api/api";

export function useTenant() {
  const [tenant, setTenant] = useState(null);
  const [status, setStatus] = useState("loading");
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function loadTenant() {
      try {
        if (!isMounted) return;

        setStatus("loading");
        setError(null);

        const subdomain = getSubdomain();

        if (!subdomain) {
          if (!isMounted) return;
          setTenant(null);
          setStatus("platform");
          return;
        }

        const response = await fetchTenant(subdomain);

        if (!isMounted) return;

        if (!response) {
          setTenant(null);
          setStatus("not_found");
          return;
        }

        setTenant(response.data?.tenant);
        setStatus("found");
      } catch (err) {
        if (!isMounted) return;
        setTenant(null);
        setError(err.message || "Failed to load tenant.");
        setStatus("error");
      }
    }

    loadTenant();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    tenant,
    status,
    error,
    loading: status === "loading",
    isPlatformDomain: status === "platform",
  };
}
